import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import CookiePolicy from "./Component/CookiePolicy";
import PolicyCenter from "./Component/PolicyCenter";
import {
  AcceptableUsePolicy,
  AccessibilityStatement,
  ComplaintsPolicy,
  IntellectualPropertyPolicy,
  LegalNotice,
  OrderPolicy,
  PaymentPolicy,
  ProductSafetyPolicy,
  PromotionsPolicy,
  StoreCommitments,
  WarrantyPolicy,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route path="/shipping-policy" element={<Delivery />} />
          <Route path="/refund-policy" element={<Returns />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/payments" element={<PaymentPolicy />} />
          <Route path="/orders" element={<OrderPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/product-safety" element={<ProductSafetyPolicy />} />
          <Route path="/promotions" element={<PromotionsPolicy />} />
          <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
          <Route path="/acceptable-use" element={<AcceptableUsePolicy />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/legal" element={<LegalNotice />} />
          <Route path="/customer-commitments" element={<StoreCommitments />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
